import { render, staticRenderFns } from "./ForeignContractorRegistrationModalDetails.vue?vue&type=template&id=46c150be&scoped=true&"
import script from "./ForeignContractorRegistrationModalDetails.vue?vue&type=script&lang=ts&"
export * from "./ForeignContractorRegistrationModalDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c150be",
  null
  
)

export default component.exports